import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Register from './container/register';
import Login from './container/login';
import RegularLogin from './container/regularLogin';
import Dashboard from './container/dashboard';
import RegularConfig from './container/regularConfigure';
import RegularSubscription from './container/regularSubscription';
import Subscribe from './container/subscribe';
import PageNotFound from './component/404';

// js && css
import './assets/scritp/jquery.min';
import './assets/scritp/jquery-ui-1.10.3.min';
import './assets/scritp/bootstrap.min';
import './assets/scritp/SmartNotification.min';
// import './assets/scritp/jarvis.widget.min';
import './assets/scritp/jquery.validate.min';
// import './assets/scritp/jquery.maskedinput.min';
import './assets/scritp/app.min';

import './assets/style/vendor/bootstrap.min.css';
// import './assets/style/vendor/font-awesome.min.css';
import './assets/style/vendor/font-awesome470.min.css';
import './assets/style/vendor/smartadmin-production.min.css';
import './assets/style/vendor/smartadmin-skins.min.css';
import './assets/style/index.css';
import './assets/style/login.css';
import './assets/style/report.css';
import './assets/style/subscribe.css';
import './assets/style/pagination.css';
import './assets/style/loading.css';

const Routes = (
  <Switch>
    <Route exact path="/" component={Register} />
    <Route exact path="/admin" component={Login} />
    <Route path="/admin/dashboard" component={Dashboard} />
    <Route exact path="/admin/subscribers" component={Dashboard} />
    <Route exact path="/admin/subscribers/subscription/:id" component={Dashboard} />
    <Route exact path="/admin/bounceEmail" component={Dashboard} />
    <Route path="/admin/tenant" component={Dashboard} />
    <Route path="/admin/regional-login" component={RegularLogin} />
    <Route path="/admin/regional-configure/:email/:t" component={RegularConfig} />
    <Route path="/admin/regional-subscription/:id" component={RegularSubscription} />
    <Route path="/subscribe/subscription/:email/regist" component={Subscribe} />
    <Route exact path="/subscribe/subscriptionemail/:email" component={Subscribe} />
    <Route exact path="/subscribe/subscriptionemail/:email/error" component={PageNotFound} />
    <Route component={PageNotFound}/>
  </Switch>
);

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js